import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  applyCustomPackageSize: {
    defaultMessage: 'Apply Custom Package Size',
    description: 'Button text to apply predefined custom package dimensions to the current package',
    id: 'NPCbLk',
  },
});
